import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { Intent } from 'signup-constants/Intent';
import { Microapp } from 'signup-constants/Microapp';
import { isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { EndpointKey } from '../http/EndpointKey';
import { getHasRefreshedNewPortalAuth, getIsNewPortalCreated, getIsNewUser } from '../store/app/selectors';
import { isPortalIdDefined } from '../store/auth/selectors';
import { getCurrentStep, isEndOfFlow } from '../store/flow/selectors';
import { isEndpointStatusSuccess } from '../store/http-responses/selectors';
import { getIsWordPressAuthFinished } from '../store/integrations/selectors';
import { hasAnsweredAllPostExistingAccountSelectedQuestions } from '../store/signup-data/selectors';
import { isFlow } from '../utils/isFlow';
import { isIntegration } from '../utils/isIntegration';
import { isIntent } from '../utils/isIntent';
import { isMicroapp } from '../utils/isMicroapp';
export const canInstallFallbackTimer = state => {
  const portalIdDefined = isPortalIdDefined(state);
  const isNewPortalCreated = getIsNewPortalCreated(state);
  const currentStep = getCurrentStep(state);
  const hasRefreshedNewPortalAuth = getHasRefreshedNewPortalAuth(state);
  const endOfFlow = isEndOfFlow(state);
  const isWPAuthFinished = getIsWordPressAuthFinished(state);
  const isNewUser = getIsNewUser(state);
  const haveScopesBeenGrantedForBlogIdeasGenerator = isEndpointStatusSuccess(EndpointKey.CheckScopesForBlogIdeasGeneratorNewUser)(state);
  if ((isIntent(Intent.blogIdeasGenerator) || isMicroapp(Microapp.BlogIdeasGenerator)) && isNewUser && !haveScopesBeenGrantedForBlogIdeasGenerator) {
    return false;
  }
  if (isIntegration(Integration.Wordpress) && !isWPAuthFinished) {
    return false;
  }
  if (isExistingUserExistingAccount(state) && !isFlow(Flow.StandaloneCmsPartner)) {
    return endOfFlow && portalIdDefined && hasAnsweredAllPostExistingAccountSelectedQuestions(state);
  }
  return endOfFlow && hasRefreshedNewPortalAuth && !currentStep && isNewPortalCreated && portalIdDefined;
};